import type { IconSvgObject } from './types';

const TerminalIcon: IconSvgObject = [
  ["path", { d: "M4.00004 17C4.00004 17 9.99999 12.5811 10 11C10 9.41884 4 5 4 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 19H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TerminalIcon;
